import type { StoryblokRichtext } from "storyblok-rich-text-react-renderer"

import type { Nullish } from "~/@types/generics"
import { truncateRichtext } from "~/lib/storyblok/utils/truncate-richtext"

export function truncate(richtext: Nullish<StoryblokRichtext>, maxChars: number) {
  if (!richtext) return null
  return truncateRichtext(richtext as StoryblokRichtext, maxChars, "...") as StoryblokRichtext
}
